import { render, staticRenderFns } from "./SplitView.vue?vue&type=template&id=51c857ae&scoped=true"
import script from "./SplitView.vue?vue&type=script&lang=js"
export * from "./SplitView.vue?vue&type=script&lang=js"
import style0 from "./SplitView.vue?vue&type=style&index=0&id=51c857ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c857ae",
  null
  
)

export default component.exports